module.exports = __webpack_public_path__ + "static/media/Circo2024_08.07547c41.webp";